module.exports = __webpack_public_path__ + "img/enigma-red-1.47408a63.png";